export default {
    PROMOTER: 1,
    ADMIN: 2,
}